import { FeedbackScreen } from '../feedback/feedback-screen.js';
import { BackfillStatusBanner } from '../shell/job-status-banners.js';

// Padding rhythm matches the settings sub-screens (px-4 py-6 sm:px-6
// sm:py-10) so the screen sits with breathing room from the main
// element's edges. Unlike the settings pages we don't constrain to a
// narrow column - the feed wants to breathe horizontally. FeedbackScreen
// owns the Community Feedback summary + the Feedback stream below it.
//
// The backfill banner sits above the feed because a channel import is what
// fills it - the user sees "Importing channel history…" here while messages
// stream in.
export function FeedbackPage(): JSX.Element {
  return (
    <div className="flex flex-col gap-4 px-4 py-6 sm:px-6 sm:py-10">
      <BackfillStatusBanner />
      <FeedbackScreen />
    </div>
  );
}
